var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-reset burger",class:{ opened: _vm.opened },attrs:{"aria-label":"Бургер меню"},on:{"click":_vm.click}},[_c('span',{staticClass:"burger__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }